import { CatalogTypePage } from './CatalogTypePage';
import { CatalogItemFormPage } from './CatalogItemFormPage';

const SHARED = {
  type: 'ELEMENT' as const,
  i18nNs: 'elements',
  listTo: '/elements' as const,
  newTo: '/elements/new' as const,
  editToParent: '/elements/$id' as const,
  editParentRouteId: '/protected/elements/$id' as const,
};

export function ElementsListPage() {
  return (
    <CatalogTypePage
      type={SHARED.type}
      i18nNs={SHARED.i18nNs}
      listTo={SHARED.listTo}
      newTo={SHARED.newTo}
      editToParent={SHARED.editToParent}
    />
  );
}

export function ElementCreatePage() {
  return (
    <CatalogItemFormPage
      type={SHARED.type}
      i18nNs={SHARED.i18nNs}
      mode="create"
      listTo={SHARED.listTo}
      editParentRouteId={SHARED.editParentRouteId}
    />
  );
}

export function ElementEditPage() {
  return (
    <CatalogItemFormPage
      type={SHARED.type}
      i18nNs={SHARED.i18nNs}
      mode="edit"
      listTo={SHARED.listTo}
      editParentRouteId={SHARED.editParentRouteId}
    />
  );
}
